import { HttpParams } from '@angular/common/http';
import { InterceptorHttpParams } from '../../../domain/interceptor.model';

export class UtilsService {
    static buildQueryParams(source: any): InterceptorHttpParams {
        let target: HttpParams = new HttpParams();
        Object.keys(source).forEach((key: string) => {
            const value: string | number | boolean | Date = source[key];
            if (typeof value !== 'undefined' && value !== null && value !== '') {
                target = target.append(key, value.toString());
            }
        });
        const object = {};
        target.keys().forEach(key => object[key] = target.get(key));
        return new InterceptorHttpParams(true, object);
    }

    static stringify = function (data) {

        const seen = [];
        return (function stringify(node) {
            if (node && node.toJSON && typeof node.toJSON === 'function') {
                node = node.toJSON();
            }

            if (node === undefined) {
                return;
            } else if (typeof node == 'number') {
                return isFinite(node) ? '' + node : 'null';
            } else if (typeof node !== 'object') {
                return JSON.stringify(node);
            }

            let i, out;
            if (Array.isArray(node)) {
                out = '[';
                for (i = 0; i < node.length; i++) {
                    if (i) out += ',';
                    out += stringify(node[i]) || 'null';
                }
                return out + ']';
            }

            if (node === null) return 'null';

            if (seen.indexOf(node) !== -1) {
                return JSON.stringify('__cycle__');
            }

            var seenIndex = seen.push(node) - 1;
            var keys = Object.keys(node).sort();
            out = '';
            for (i = 0; i < keys.length; i++) {
                var key = keys[i];
                var value = stringify(node[key]);

                if (!value) continue;
                if (out) out += ',';
                out += JSON.stringify(key) + ':' + value;
            }
            seen.splice(seenIndex, 1);
            return '{' + out + '}';
        })(data);
    };
}
